import { HTMLProps } from 'react';

type PillTint = 'green';

export const Pill: React.FC<HTMLProps<HTMLDivElement> & { tint: PillTint; isActive?: boolean }> = ({
    children,
    className,
    tint = 'green',
    isActive = false,
    ...rest
}) => {
    return (
        <div
            className={`px-3 py-1 rounded border border-bnd-green font-medium cursor-pointer transition ${
                isActive
                    ? 'bg-bnd-green text-bnd-white-1'
                    : 'text-bnd-green hover:bg-bnd-green hover:text-bnd-white-1'
            } ${className}`}
            {...rest}
        >
            {children}
        </div>
    );
};
